import { render, staticRenderFns } from "./ProductsModuleRoot.vue?vue&type=template&id=2071bf1f&scoped=true&lang=html&"
import script from "./ProductsModuleRoot.vue?vue&type=script&lang=js&"
export * from "./ProductsModuleRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071bf1f",
  null
  
)

export default component.exports